/* Sueve theme – small, dependency-free enhancements.
   Every feature here also works without JavaScript through normal Shopify forms and links. */
(() => {
  const S = window.Sueve || { routes: {}, strings: {} };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Dialogs (menu, search, size guide, bag) ---------- */
  const openDialog = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    dialog._trigger = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    const focusTarget = $('input[type="search"]', dialog);
    if (focusTarget) focusTarget.focus();
  };
  const closeDialog = (dialog) => { if (dialog && dialog.open) dialog.close(); };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-dialog]');
    if (opener) { e.preventDefault(); openDialog(opener.dataset.openDialog, opener); return; }
    const closer = e.target.closest('[data-close-dialog]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG') closeDialog(e.target); // click on backdrop
  });
  document.addEventListener('close', (e) => {
    if (e.target.tagName !== 'DIALOG') return;
    document.documentElement.style.overflow = '';
    if (e.target._trigger && e.target._trigger.focus) e.target._trigger.focus();
  }, true);

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */
  const headerWrap = $('.section-header');
  if (headerWrap) {
    let lastY = window.scrollY;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        headerWrap.classList.toggle('is-hidden', y > lastY && y > 200);
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Cart ---------- */
  const drawerSectionId = 'cart-drawer';

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.hidden = count === 0;
      const visible = el.querySelector('[aria-hidden]');
      if (visible) visible.textContent = count;
    });
  };

  const renderSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const current = document.querySelector(`[data-cart-section="${id}"]`);
      const fresh = doc.querySelector(`[data-cart-section="${id}"]`);
      if (!current || !fresh) return;
      if (current.tagName === 'DIALOG') {
        const inner = $('.drawer__inner', current);
        const freshInner = $('.drawer__inner', fresh);
        if (inner && freshInner) inner.replaceWith(freshInner);
      } else {
        current.innerHTML = fresh.innerHTML;
      }
    });
  };

  const sectionIds = () => {
    const ids = new Set([drawerSectionId]);
    $$('[data-cart-section]').forEach((el) => ids.add(el.dataset.cartSection));
    return Array.from(ids);
  };

  const openCart = () => {
    if (S.cartType === 'page') { window.location.href = S.routes.cart_url; return; }
    openDialog('CartDrawer');
  };

  document.addEventListener('click', (e) => {
    const bag = e.target.closest('[data-open-cart]');
    if (bag && S.cartType !== 'page' && document.getElementById('CartDrawer')) {
      e.preventDefault();
      openDialog('CartDrawer', bag);
    }
  });

  const addToCart = async (form, submitter) => {
    const data = new FormData(form);
    if (submitter && submitter.name === 'id') data.set('id', submitter.value);
    if (!data.get('id')) return false;
    data.append('sections', sectionIds().join(','));
    data.append('sections_url', window.location.pathname);
    const res = await fetch(S.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || S.strings.genericError);
    renderSections(json.sections);
    const cart = await (await fetch(`${S.routes.root_url.replace(/\/$/, '')}/cart.js`)).json();
    updateCount(cart.item_count);
    return true;
  };

  const changeLine = async (line, quantity) => {
    const scope = document.querySelectorAll('[data-cart-section]');
    scope.forEach((el) => el.classList.add('is-updating'));
    try {
      const res = await fetch(S.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: sectionIds(), sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || S.strings.genericError);
      renderSections(json.sections);
      updateCount(json.item_count);
    } catch (err) {
      window.alert(err.message || S.strings.genericError);
    } finally {
      document.querySelectorAll('[data-cart-section]').forEach((el) => el.classList.remove('is-updating'));
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.dataset.lineChange, btn.dataset.qty);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) changeLine(input.dataset.lineInput, input.value);
  });

  /* Quick add on product cards */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter;
    if (btn) btn.classList.add('is-loading');
    try { await addToCart(form, btn); openCart(); }
    catch (err) { window.alert(err.message); }
    finally { if (btn) btn.classList.remove('is-loading'); }
  });


  /* ---------- Product gallery (every product page) ----------
     Uses native horizontal scrolling with scroll-snap, so swiping feels natural on iPhone and Android
     and never blocks vertical page scrolling. Arrows, thumbnails and keyboard drive the same track. */
  const initGallery = (root) => {
    const track = $('[data-gallery]', root);
    if (!track || root._gallery) return;
    const slides = $$('.pgallery__slide', track);
    const thumbs = $$('[data-gallery-thumb]', root);
    const dots = $$('[data-gallery-dot]', root);
    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    const counter = $('[data-gallery-current]', root);
    const status = $('[data-gallery-status]', root);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = -1; // forces the first update to run

    const setActive = (i, announce) => {
      if (i === current && !announce) return;
      current = i;
      if (counter) counter.textContent = i + 1;
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      thumbs.forEach((t, n) => {
        if (n === i) {
          t.setAttribute('aria-current', 'true');
          const list = t.closest('.pgallery__thumbs');
          if (list && list.scrollHeight > list.clientHeight + 2) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
        } else t.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      if (announce && status && status.dataset.template) status.textContent = status.dataset.template.replace('[n]', i + 1);
    };

    const goTo = (i, announce = true) => {
      const target = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[target].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setActive(target, announce);
    };

    // Keep counter, dots and thumbnails in sync with swipes
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        setActive(Math.max(0, Math.min(slides.length - 1, i)), false);
        ticking = false;
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.galleryThumb))));

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'Home') { e.preventDefault(); goTo(0); }
      if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
    });

    // Keep the current image in place when the screen is resized or rotated
    window.addEventListener('resize', () => { track.scrollTo({ left: slides[current].offsetLeft, behavior: 'auto' }); }, { passive: true });

    setActive(0, false);
    root._gallery = {
      goTo,
      goToMedia: (mediaId) => {
        const i = slides.findIndex((sl) => sl.dataset.mediaId === String(mediaId));
        if (i > -1) goTo(i, false);
      }
    };
  };
  $$('[data-gallery-root]').forEach(initGallery);

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    const form = $('[data-product-form]', root);
    if (!jsonEl || !form) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const formError = $('[data-form-error]', form);
    const stock = $('[data-stock]', root);
    const priceWrap = $('[data-price-wrap]', root);
    const stickyBar = $('[data-sticky-atc]', root);
    const stickyBtn = $('[data-sticky-add]', root);
    const stickyLabel = $('[data-sticky-label]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const fieldsets = $$('fieldset[data-option-index]', form);

    const selected = () => fieldsets.map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const priceHTML = (v) => v.compare_at_price
      ? `<div class="price price--sale"><span class="price__current">${v.price}</span><s class="price__compare">${v.compare_at_price}</s></div>`
      : `<div class="price"><span class="price__current">${v.price}</span></div>`;

    const setLabel = (text, disabled) => {
      [addLabel, stickyLabel].forEach((el) => { if (el) el.textContent = text; });
      [addBtn, stickyBtn].forEach((b) => { if (b) b.disabled = !!disabled; });
    };

    // Mark option values that are sold out given the other chosen options
    const markAvailability = () => {
      const current = selected();
      fieldsets.forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const test = current.slice();
          test[idx] = input.value;
          const possible = product.variants.filter((v) => v.options.every((o, i) => (i === idx ? o === input.value : (test[i] == null || o === test[i]))));
          const available = possible.some((v) => v.available);
          const label = input.nextElementSibling;
          if (label) {
            label.classList.toggle('is-unavailable', !available);
            label.setAttribute('aria-label', available ? input.value : `${input.value} (${S.strings.soldOut})`);
          }
        });
      });
    };

    const update = () => {
      const opts = selected();
      fieldsets.forEach((fs, i) => {
        const chosen = $('[data-option-chosen]', fs);
        if (chosen) chosen.textContent = opts[i] ? `: ${opts[i]}` : '';
      });
      markAvailability();
      if (opts.some((o) => o === null)) { idInput.value = ''; setLabel(S.strings.selectSize, false); return; }

      const variant = findVariant(opts);
      if (!variant) {
        idInput.value = '';
        setLabel(S.strings.unavailable, true);
        if (stock) stock.textContent = '';
        return;
      }
      idInput.value = variant.id;
      if (priceWrap) priceWrap.innerHTML = priceHTML(variant);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(variant);
      setLabel(variant.available ? S.strings.addToBag : S.strings.soldOut, !variant.available);
      if (stock) stock.textContent = variant.available ? '' : S.strings.soldOut;
      fieldsets.forEach((fs) => { fs.classList.remove('has-error'); const err = $('[data-option-error]', fs); if (err) err.hidden = true; });
      if (formError) formError.hidden = true;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Show the variant's own image, if it has one; the gallery itself is never rebuilt
      const galleryRoot = $('[data-gallery-root]', root);
      if (variant.media_id && galleryRoot && galleryRoot._gallery) galleryRoot._gallery.goToMedia(variant.media_id);
    };

    fieldsets.forEach((fs) => fs.addEventListener('change', update));
    if (fieldsets.length) markAvailability();

    const showSizeError = () => {
      const missing = fieldsets.find((fs) => !$('input:checked', fs));
      if (!missing) return;
      missing.classList.add('has-error');
      const err = $('[data-option-error]', missing);
      if (err) { err.textContent = S.strings.chooseSizeError; err.hidden = false; }
      missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const first = $('input', missing);
      if (first) first.focus({ preventScroll: true });
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!idInput.value) { showSizeError(); return; }
      addBtn.classList.add('is-loading');
      if (formError) formError.hidden = true;
      try {
        await addToCart(form);
        openCart();
      } catch (err) {
        if (formError) { formError.textContent = err.message; formError.hidden = false; }
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });

    if (stickyBtn) stickyBtn.addEventListener('click', () => {
      if (!idInput.value) { showSizeError(); return; }
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });

    // Sticky add-to-bag appears once the main button scrolls out of view (mobile only via CSS)
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      stickyBar.hidden = false;
      new IntersectionObserver(([entry]) => {
        const below = entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && below);
      }).observe(addBtn);
    }

  });

  /* Quantity steppers on the product page */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-qty]'));
    const step = btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
  });

  /* ---------- Related products (loaded after the page) ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* recommendations are optional */ }
  });

  /* ---------- Collection sort: apply immediately ---------- */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-sort]')) e.target.form.submit();
  });
})();
